import FieldWrapper from '../Field-wrapper';
import styles from '../Fields.module.less';
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
const TextAreaInput = ({
    disabled,
    id,
    inputClassName,
    name,
    obscured,
    onChange,
    onFocus,
    onKeyDown,
    placeholder,
    required,
    rows = 3,
    value
}) => (
    <textarea
        cols="35"
        rows={rows}
        className={styles[inputClassName]}
        id={id || name}
        name={name}
        type={obscured ? 'password' : 'text'}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        value={value}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
    />
);
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export default FieldWrapper(TextAreaInput, { reduxForm: true });
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export const TextField = FieldWrapper(TextAreaInput);
